module.exports = __webpack_public_path__ + "static/media/pl.4bbf84a4.svg";